import { driver } from 'driver.js'
import 'driver.js/dist/driver.css'
import './useFinanceTour.css' // reutiliza o tema rosa QueMimo

const TOUR_SEEN_KEY = 'qm_dashboard_tour_v1'

function buildSteps() {
  const steps = []

  if (document.querySelector('[data-tour="dash-stats"]')) {
    steps.push({
      element: '[data-tour="dash-stats"]',
      popover: {
        title: '📊 Seus números',
        description:
          'Aqui você acompanha o total <strong>arrecadado</strong> em todos os seus eventos e quantos eventos estão <strong>ativos</strong> agora. Clique em cada card para ir direto à seção correspondente.',
        side: 'bottom',
        align: 'start',
      },
    })
  }

  steps.push(
    {
      element: '[data-tour="dash-actions"]',
      popover: {
        title: '⚡ Ações principais',
        description:
          '<strong>Criar Evento</strong> inicia seu novo evento em 3 passos simples. <strong>Meus Eventos</strong> lista tudo que você já criou — ativos, pendentes e encerrados.',
        side: 'bottom',
        align: 'start',
      },
    },
  )

  if (document.querySelector('[data-tour="dash-events"]')) {
    steps.push({
      element: '[data-tour="dash-events"]',
      popover: {
        title: '🎉 Eventos ativos',
        description:
          'Seus eventos em andamento aparecem aqui. Toque em qualquer um para ver detalhes, compartilhar o link ou acompanhar quem já presenteou.',
        side: 'top',
        align: 'start',
      },
    })
  }

  steps.push({
    element: '[data-tour="dash-shortcuts"]',
    popover: {
      title: '🔗 Atalhos',
      description:
        'Acesso rápido às seções mais usadas: seus dados pessoais, dados bancários para receber, finanças e configurações de segurança. O ícone <strong>!</strong> indica que algo precisa de atenção.',
      side: 'top',
      align: 'start',
    },
  })

  return steps
}

export function useDashboardTour() {
  function startTour() {
    const driverObj = driver({
      showProgress: true,
      progressText: '{{current}} de {{total}}',
      nextBtnText: 'Próximo →',
      prevBtnText: '← Anterior',
      doneBtnText: '✓ Entendi',
      popoverClass: 'qm-tour-popover',
      steps: buildSteps(),
      onDestroyed: () => {
        localStorage.setItem(TOUR_SEEN_KEY, '1')
      },
    })
    driverObj.drive()
  }

  function startTourIfFirstVisit() {
    if (!localStorage.getItem(TOUR_SEEN_KEY)) {
      setTimeout(startTour, 700)
    }
  }

  return { startTour, startTourIfFirstVisit }
}
